import { Link } from "react-router-dom";
import { categories } from "@/mocks/comics";

export default function CategoryGrid() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950" style={{ fontFamily: "var(--font-heading)" }}>
            漫画分类
          </h2>
          <p className="text-sm text-foreground-600 mt-3 max-w-lg mx-auto">
            八大分类，精准定位您喜欢的漫画类型，快速找到心仪作品
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center p-6 md:p-8 rounded-lg bg-background-100 hover:bg-background-200/70 transition-all duration-300 cursor-pointer border border-background-200/70 hover:border-primary-200"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300">
                <i className={`${cat.icon} text-xl md:text-2xl`}></i>
              </div>
              <h3 className="mt-4 text-sm md:text-base font-semibold text-foreground-950 whitespace-nowrap">
                {cat.name}
              </h3>
              <p className="mt-1 text-xs text-foreground-600 text-center line-clamp-2">
                {cat.description}
              </p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}